module.exports = __webpack_public_path__ + "img/layout_time_arc.1223954c.svg";